// apijs
import service from './../../http4.js'


export const getexminelist = (data) => {
	return service({
		url: 'QuestionBank/GetPaperList?Pageindex='+ data.Pageindex + "&PageSize="+ data.PageSize + "&SPA_PaperTitle="+data.SPA_PaperTitle,
		method: 'get'
	})
};



export const getexmineks = (data) => {
	return service({
		url: 'QuestionBank/GetUserSentPaper?UI_GUID='+ data.UI_GUID + "&SSP_Status="+ data.SSP_Status,
		method: 'get'
	})
};

// https://www.hngtsd.net/api/QuestionBank/Examination?SPA_GUID=f89247fcebd04cd19af937aeb3b
export const getExamination = (data) => {
	return service({
		url: 'QuestionBank/Examination?SPA_GUID='+ data.SPA_GUID,
		method: 'get'
	})
};


export const setQuestionBank = (data) => {
	return service({
		url: 'QuestionBank/AjaxExamination',
		method: 'post',
		data
	})
};


export const getGetusersentpaper = (data) => {
	return service({
		url: 'QuestionBank/GetUserSentPaper?UI_GUID='+data+'&SSP_Status=1',
		method: 'get',
	})
};

export const getGetusersentpapers = (data) => {
	return service({
		url: 'QuestionBank/GetUserSentPaper?UI_GUID='+data+'&SSP_Status=0',
		method: 'get',
	})
};